export default __webpack_public_path__ + "static/media/baby dedication header.e6e38c63.jpg";